/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TableConfigDto } from './tableConfigDto';


export interface CustomFieldCompositionDto { 
    valueType: CustomFieldCompositionDto.ValueTypeEnum;
    cardinalityType: CustomFieldCompositionDto.CardinalityTypeEnum;
    multipleChoiceOptions: Array<string>;
    unit?: CustomFieldCompositionDto.UnitEnum;
    tableConfig?: TableConfigDto;
}
export namespace CustomFieldCompositionDto {
    export type ValueTypeEnum = 'Boolean' | 'Integer' | 'Double' | 'String' | 'Longtext' | 'LongtextWithPresets' | 'MultipleChoice' | 'LocalDate' | 'LocalDateTime' | 'Attachment' | 'Table' | 'Signature';
    export const ValueTypeEnum = {
        Boolean: 'Boolean' as ValueTypeEnum,
        Integer: 'Integer' as ValueTypeEnum,
        Double: 'Double' as ValueTypeEnum,
        String: 'String' as ValueTypeEnum,
        Longtext: 'Longtext' as ValueTypeEnum,
        LongtextWithPresets: 'LongtextWithPresets' as ValueTypeEnum,
        MultipleChoice: 'MultipleChoice' as ValueTypeEnum,
        LocalDate: 'LocalDate' as ValueTypeEnum,
        LocalDateTime: 'LocalDateTime' as ValueTypeEnum,
        Attachment: 'Attachment' as ValueTypeEnum,
        Table: 'Table' as ValueTypeEnum,
        Signature: 'Signature' as ValueTypeEnum
    };
    export type CardinalityTypeEnum = 'Single' | 'Multiple';
    export const CardinalityTypeEnum = {
        Single: 'Single' as CardinalityTypeEnum,
        Multiple: 'Multiple' as CardinalityTypeEnum
    };
    export type UnitEnum = 'Meter' | 'Centimeter' | 'Millimeter' | 'Kilogram' | 'Gram' | 'Celsius' | 'Liter' | 'Milliliter' | 'SquareMeter' | 'Kilowatt' | 'KilowattHour' | 'Bar' | 'Pascal' | 'Percent' | 'Euro' | 'GermanHardness' | 'Tonne' | 'Megawatt' | 'MegawattHour' | 'CubicMeter' | 'MicrosiemensPerCentimeter' | 'MillimolPerLiter' | 'MilligramPerLiter' | 'MilligramPerCubicMeter' | 'LiterPerMinute' | 'LiterPerHour' | 'Volt' | 'Ampere' | 'Ohm' | 'Kelvin' | 'Hectopascal';
    export const UnitEnum = {
        Meter: 'Meter' as UnitEnum,
        Centimeter: 'Centimeter' as UnitEnum,
        Millimeter: 'Millimeter' as UnitEnum,
        Kilogram: 'Kilogram' as UnitEnum,
        Gram: 'Gram' as UnitEnum,
        Celsius: 'Celsius' as UnitEnum,
        Liter: 'Liter' as UnitEnum,
        Milliliter: 'Milliliter' as UnitEnum,
        SquareMeter: 'SquareMeter' as UnitEnum,
        Kilowatt: 'Kilowatt' as UnitEnum,
        KilowattHour: 'KilowattHour' as UnitEnum,
        Bar: 'Bar' as UnitEnum,
        Pascal: 'Pascal' as UnitEnum,
        Percent: 'Percent' as UnitEnum,
        Euro: 'Euro' as UnitEnum,
        GermanHardness: 'GermanHardness' as UnitEnum,
        Tonne: 'Tonne' as UnitEnum,
        Megawatt: 'Megawatt' as UnitEnum,
        MegawattHour: 'MegawattHour' as UnitEnum,
        CubicMeter: 'CubicMeter' as UnitEnum,
        MicrosiemensPerCentimeter: 'MicrosiemensPerCentimeter' as UnitEnum,
        MillimolPerLiter: 'MillimolPerLiter' as UnitEnum,
        MilligramPerLiter: 'MilligramPerLiter' as UnitEnum,
        MilligramPerCubicMeter: 'MilligramPerCubicMeter' as UnitEnum,
        LiterPerMinute: 'LiterPerMinute' as UnitEnum,
        LiterPerHour: 'LiterPerHour' as UnitEnum,
        Volt: 'Volt' as UnitEnum,
        Ampere: 'Ampere' as UnitEnum,
        Ohm: 'Ohm' as UnitEnum,
        Kelvin: 'Kelvin' as UnitEnum,
        Hectopascal: 'Hectopascal' as UnitEnum
    };
}


